function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "Noitfication icon");

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "\\u2693\\uFE0F-The-Shipyard",
  stroke: "none",
  strokeWidth: 1
}, React.createElement("g", {
  id: "\\u260DQronoport-/-Foundation-/-icons-/-bell",
  transform: "translate(-4.000000, -2.000000)"
}, React.createElement("path", {
  d: "M18,13.18 L18,9.99999999 C17.9970353,7.07447928 15.8846041,4.57758553 13,4.08999999 L13,2.99999999 C13,2.44771524 12.5522848,1.99999999 12,1.99999999 C11.4477152,1.99999999 11,2.44771524 11,2.99999999 L11,4.08999999 C8.11539594,4.57758553 6.00296467,7.07447928 5.99999999,9.99999999 L5.99999999,13.18 C4.8042713,13.6027483 4.00356436,14.7317451 3.99999999,16 L3.99999999,18 C3.99999999,18.5522848 4.44771524,19 4.99999999,19 L8.14,19 C8.61339781,20.7419604 10.1948597,21.9510005 12,21.9510005 C13.8051403,21.9510005 15.3866022,20.7419604 15.86,19 L19,19 C19.5522848,19 20,18.5522848 20,18 L20,16 C19.9964356,14.7317451 19.1957287,13.6027483 18,13.18 Z M8,9.99999999 C8,7.790861 9.790861,5.99999999 12,5.99999999 C14.209139,5.99999999 16,7.790861 16,9.99999999 L16,13 L8,13 L8,9.99999999 Z M12,20 C11.2897779,19.9957131 10.6351046,19.6150891 10.28,19 L13.72,19 C13.3648954,19.6150891 12.7102221,19.9957131 12,20 Z M18,17 L5.99999999,17 L5.99999999,16 C5.99999999,15.4477153 6.44771524,15 6.99999999,15 L17,15 C17.5522848,15 18,15.4477153 18,16 L18,17 Z",
  id: "\\uD83C\\uDF08-COLOR"
})));

var SvgBell = function SvgBell(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "16px",
    height: "20px",
    viewBox: "0 0 16 20",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgBell, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bell.318914e7.svg";
export { ForwardRef as ReactComponent };